import {
  Timestamp,
  addDoc,
  collection,
  doc,
  updateDoc,
} from "firebase/firestore";

export const useApplyChecklistToDocuments = defineStore(
  "/apply/checklists/documents",
  () => {
    const applyChecklistToDocument = async (
      checklistId: string,
      checklistPath: string,
      documentId: string
    ) => {
      const db = useFirestore();

      const docRef = doc(db, `/documents/${documentId}`);
      await updateDoc(docRef, {
        checklistId: checklistId,
        checklistPath: checklistPath,
        state: DocumentState.submitted,
      });

      const serverTasksRef = collection(
        db,
        `taskQueues/reloadDocumentChecklist/queuedTasks`
      );

      await addDoc(serverTasksRef, {
        createdOnTimestamp: Timestamp.now(),
        documentId: documentId,
        checklistId: checklistId,
        checklistPath: checklistPath,
      });
    };

    const applyChecklistToDocumentNow = async (
      checklistId: string,
      checklistPath: string,
      documentId: string,
      showEvaluation: boolean = true
    ) => {
      const db = useFirestore();

      const docRef = doc(db, `/documents/${documentId}`);
      await updateDoc(docRef, {
        checklistId: checklistId,
        checklistPath: checklistPath,
      });

      await $fetch(`/api/document/${documentId}/checklist/reload`, {
        method: "POST",
        headers: await useApiHeaders(),
        body: {
          showEvaluation: showEvaluation,
        },
      });
    };

    return {
      applyChecklistToDocument,
      applyChecklistToDocumentNow,
    };
  }
);
